import { useNavigate } from "react-router";
import logo from "../logo.png";
import { JSX } from "react";
import "./Header.css";

export default function Header({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  return (
    <div className="Header">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h3>Rate It!</h3>
        <div
          className="App-link"
          onClick={() => {
            navigate("/");
          }}
        >
          Home
        </div>
        <div
          className="App-link"
          onClick={async () => {
            await fetch("/api/logout");
            await navigate("/user/login");
          }}
        >
          Logout
        </div>
      </header>
      <div className="App-content">{children}</div>
    </div>
  );
}
